<template lang="pug">
#manageSKUModal.modal.fade(
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
)
  .modal-dialog.modal-dialog-centered.modal-lg.position-relative(
    role="document"
  )
    .modal-content
      .modal-header.border-0.pb-0
        button.text-primary.close(
          type="button"
          data-dismiss="modal"
          aria-label="Close"
        )
          span(aria-hidden="true") &times;
      .modal-body.pb-0
        .row
          .col-6.d-none.d-lg-inline
            .sku-large-image.position-relative.overflow-hidden
              img.position-absolute.w-100(:src="largeImageSrc")
          .col-12.col-lg-6
            .sku.overflow-hidden(v-if="sku.commodity")
              .sku-image-wrapper.d-flex.d-lg-none
                img.sku-image(
                  v-for="(img, i) in sku.commodity.imageUrls"
                  :key="`img-${i}`"
                  :src="img"
                  :class="{ 'ml-3': i > 0, single: sku.commodity.imageUrls.length < 2 }"
                )
              .group-buy-badge.mt-2(v-show="sku.allowGroupBuying") 團購任務
              .font-weight-bold(v-if="sku.commodity.brand !== 'unknown'") {{ $t(`__${sku.commodity.brand}`) }}
              .name.font-weight-medium.mb-2 {{ sku.commodity.name }}
              .pb-1
                span.price ${{ sku.commodity.variants[0].sellingPrice }}
                span.sharing-profit.border.border-primary.text-primary.px-2.py-1.ml-2 分潤 ${{ sku.commodity.variants[0].sellerProfit }}
          .col-12.mt-3
            .sku-image-wrapper.mr-auto.d-none.d-lg-inline(v-if="sku.commodity")
              img.sku-image.pointer-cursor(
                v-for="(img, i) in sku.commodity.imageUrls"
                :key="`small-img-${i}`"
                :src="img"
                :class="{ 'ml-3': i > 0 }"
                @click="selectedImgOrder = i"
              )
          .col-12.mt-3
            .form-group
              .name.font-weight-bold 商品推薦留言
              .text-light.mb-2(v-show="commentTip") {{ commentTip }}
              textarea.form-control(
                rows="3"
                v-model="comment"
                :placeholder="placeholder"
                @focus="focus"
              )
          .col-12.mt-3
            .form-group
              .name.font-weight-bold 導覽影片
              .text-light.mb-2 你可以複製其他平台的連結到導覽影片欄位。導覽影片支援嵌入 Youtube、Instagram 貼文影片、Instagram IG TV 影片。上傳影片等同你已經同意 LinkBy 的規則、隱私權法則。
              .thumbnail.position-relative(v-if="thumbnailUrl")
                //- button.btn.btn-danger.position-absolute(
                //-   type="button"
                //-   @click="deleteVideo"
                //- ) 刪除
                img.w-100(:src="thumbnailUrl")
              input.form-control.mt-3(
                type="url"
                v-model="youtubeUrl"
                @change="enterYoutubeUrl"
                placeholder="貼上導覽影片連結"
              )
              input.form-control.mt-3(
                input="text"
                v-model="youtubeTitle"
                placeholder="導覽影片名稱"
              )
      .modal-footer
        .w-100
          button.btn.btn-outline-danger.my-2(type="button" v-if="isLoading")
            .dots.one.mx-2.rounded-circle
            .dots.two.mx-2.rounded-circle
            .dots.three.mx-2.rounded-circle
          button.btn.btn-outline-danger.my-2(
            type="button"
            @click="submit"
            v-else
          ) 從商品設定內移除商品
          button.btn.btn-primary.my-2.ml-0.ml-lg-2(
            type="button"
            @click="update"
          ) 儲存更改
</template>

<script>
import _ from 'lodash';
import CustomDropdown from '@/components/sku/CustomDropdown.vue';
import { mapGetters } from 'vuex';
import defaultImage from '@/assets/images/empty-product.png';

export default {
  name: 'ManageSKUModal',
  components: {
    CustomDropdown,
  },
  props: {
    sku: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      selectedImgOrder: 0,
      comment: '',
      youtubeUrl: '',
      youtubeTitle: '',
      thumbnailUrl: null,
    };
  },
  computed: {
    ...mapGetters('sku', [
      'supplyTips',
    ]),
    largeImageSrc() {
      if (this.sku.commodity && this.sku.commodity.imageUrls.length) {
        return this.sku.commodity.imageUrls[this.selectedImgOrder];
      }
      return defaultImage;
    },
    commentTip() {
      if (this.sku.commodity && this.sku.commodity.subcategory) {
        const c = this.supplyTips.find((s) => s.subcategory === this.sku.commodity.subcategory);
        if (c) {
          return c.commentTip || '';
        }
      }
      return '';
    },
    defaultComment() {
      if (this.sku.commodity && this.sku.commodity.subcategory) {
        const c = this.supplyTips.find((s) => s.subcategory === this.sku.commodity.subcategory);
        if (c) {
          return c.defaultComment || '這是我幫你挑的，推薦給你！';
        }
      }
      return '這是我幫你挑的，推薦給你！';
    },
    placeholder() {
      if (this.defaultComment) {
        return `(系統預設商品推薦留言) ${this.defaultComment}`;
      }
      return '';
    },
  },
  mounted() {
    $('#manageSKUModal').on('hidden.bs.modal', () => {
      this.isLoading = false;
      this.selectedImgOrder = 0;
      this.youtubeUrl = '';
      this.youtubeTitle = '';
      this.thumbnailUrl = null;
    });

    $('#manageSKUModal').on('shown.bs.modal', async () => {
      this.comment = this.sku.comment || '';
      this.youtubeUrl = this.sku.youtubeUrl || '';
      this.youtubeTitle = this.sku.youtubeTitle || '';
      const id = this.getYoutubeID(this.youtubeUrl);
      if (id) {
        this.thumbnailUrl = this.getYoutubeThumbnailUrl(id);
      } else if (this.youtubeUrl.includes('www.instagram.com')) {
        this.thumbnailUrl = await this.getInstagramThumbnailUrl(this.youtubeUrl);
      }
    });
  },
  methods: {
    submit() {
      this.isLoading = true;
      this.$emit('selectSKU', this.sku);
    },
    update() {
      this.isLoading = true;
      this.$emit('updateSKU', {
        supplyID: this.sku._id,
        comment: this.comment,
        youtubeUrl: this.youtubeUrl || null,
        youtubeTitle: this.youtubeTitle,
      });
    },
    focus() {
      if (!this.comment && this.defaultComment) {
        this.comment = this.defaultComment;
      }
    },
    deleteVideo() {
      this.youtubeUrl = '';
      this.youtubeTitle = '';
    },
    async enterYoutubeUrl() {
      this.thumbnailUrl = null;
      const id = this.getYoutubeID(this.youtubeUrl);
      if (id) {
        const { data: { items } } = await this.$api.utilities.getYoutubeVideos({
          part: 'snippet',
          id,
        });

        if (_.has(items, '[0].snippet.title')) {
          this.youtubeTitle = items[0].snippet.title;
        }
        this.thumbnailUrl = this.getYoutubeThumbnailUrl(id);
      }
      if (this.youtubeUrl.includes('www.instagram.com')) {
        this.thumbnailUrl = await this.getInstagramThumbnailUrl(this.youtubeUrl);
      }
    },
    getYoutubeID(url) {
      if (/youtu\.?be/.test(url)) {
        // Look first for known patterns
        const patterns = [
          /youtu\.be\/([^#&?]{11})/, // youtu.be/<id>
          /\?v=([^#&?]{11})/, // ?v=<id>
          /&v=([^#&?]{11})/, // &v=<id>
          /embed\/([^#&?]{11})/, // embed/<id>
          /\/v\/([^#&?]{11})/, // /v/<id>
        ];

        // If any pattern matches, return the ID
        for (let i = 0; i < patterns.length; i += 1) {
          if (patterns[i].test(url)) {
            return patterns[i].exec(url)[1];
          }
        }
      }
      return null;
    },
    getYoutubeThumbnailUrl(id) {
      return `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
    },
    async getInstagramThumbnailUrl(permalink) {
      try {
        const { data: { thumbnail_url: thumbnailUrl } } = await this.$api.utilities.getInstagramOembed({
          permalink,
          fields: 'thumbnail_url',
        });
        return thumbnailUrl;
      } catch (error) {
        this.$logger.error(error);
        return null;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@import '@/assets/styles/mobile-modal.sass'
@import '@/assets/styles/variables'

.modal-content
  height: 100%

  @media only screen and (min-width: 768px)
    height: auto

.sku
  font-size: 16px

  &-image-wrapper
    overflow-y: auto
    -ms-overflow-style: none

    &::-webkit-scrollbar
      display: none

  &-large-image
    border-radius: 2px
    padding-bottom: 100%

    img
      top: 0
      left: 0

  &-image
    max-width: 70%
    max-height: 220px
    border-radius: 2px

    &.single
      max-width: 100%

    @media only screen and (min-width: 992px)
      width: 65px
      height: 65px

  .sharing-profit
    font-size: 14px
    border-radius: 4px

.name
  font-size: 16px

.thumbnail
  border-radius: 8px
  overflow: hidden

  @media only screen and (min-width: 768px)
    max-width: 360px

  button
    top: 12px
    right: 12px

textarea::placeholder
  color: $primary-300 !important
textarea::-webkit-input-placeholder
  color: $primary-300 !important
textarea::-moz-placeholder
  color: $primary-300 !important

input::placeholder
  text-align: center
  font-weight: bold
  color: $primary-300 !important
input::-webkit-input-placeholder
  text-align: center
  font-weight: bold
  color: $primary-300 !important
input::-moz-placeholder
  text-align: center
  font-weight: bold
  color: $primary-300 !important

.btn-primary
  .dots
    background-color: #fff

.btn-outline-danger
  background-color: #fff !important
  .dots
    background-color: $danger
</style>
